<template>
  <div class="park">
    <div>
      <div class="park-btn">
        <el-button type="primary" size="mini" @click="updateDicDialog()"
          >添加数据</el-button
        >
      </div>
      <el-tabs v-model="tabName" type="card">
        <el-tab-pane label="数据查询" name="1">
          <div class="park-btn">
            <span class="f14 bold">数据状态：</span>
            <el-radio
              v-model="dataArgs.status"
              :label="-1"
              @change="changeTypeRadio()"
              >全部</el-radio
            >
            <el-radio
              v-model="dataArgs.status"
              :label="0"
              @change="changeTypeRadio()"
              >失效</el-radio
            >
            <el-radio
              v-model="dataArgs.status"
              :label="1"
              @change="changeTypeRadio()"
              >有效</el-radio
            >
          </div>
          <div class="line"></div>
          <div class="main-table">
            <el-table :data="dicList" border style="width: 100%">
              <el-table-column prop="id" label="ID"> </el-table-column>
              <el-table-column prop="position" label="位置"> </el-table-column>
              <el-table-column label="content" width="400px">
                <template slot-scope="scope">
                  <div v-if="scope.row.content">
                    {{ scope.row.content.substr(0, 100) }}
                  </div>
                  <!-- <p>{{scope.row.content}}</p> -->
                </template>
              </el-table-column>

              <el-table-column label="创建日期">
                <template slot-scope="scope">
                  <div>
                    {{ $dtime(scope.row.createTime).format("YYYY-MM-DD") }}
                  </div>
                </template>
              </el-table-column>

              <el-table-column label="状态">
                <template slot-scope="scope">
                  <el-tag type="success" v-if="scope.row.status == 1"
                    >有效</el-tag
                  >
                  <el-tag type="danger" v-else>已失效</el-tag>
                </template>
              </el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    size="mini"
                    @click="updateDicDialog(scope.row)"
                    >修改</el-button
                  >
                  <!--<el-button type="text" size="mini" @click="deleteDicDialog(scope.row)">{{scope.row.isDelete == true ? '恢复':'删除'}}</el-button>-->
                </template>
              </el-table-column>
            </el-table>
            <div style="margin-bottom: 30px; margin-top: 20px">
              <el-pagination
                background
                layout="total,prev, pager, next"
                :total="dataArgs.total"
                :page-size="dataArgs.take"
                :current-page="dataArgs.skip / dataArgs.take + 1"
                @current-change="changePage"
                style="float: right"
              >
              </el-pagination>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="数据更新" name="2">
          <el-form ref="form" :model="dicEntity" label-width="80px">
            <el-form-item label="位置">
              <el-input v-model="dicEntity.position"></el-input>
            </el-form-item>
            <el-form-item label="状态">
              <el-select v-model="dicEntity.status">
                <el-option label="有效" :value="parseInt(1)"></el-option>
                <el-option label="失效" :value="parseInt(0)"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="内容"> </el-form-item>
          </el-form>
          <div>
            <templateUeditor v-model="dicEntity.content"></templateUeditor>
          </div>
          <div style="margin-top: 20px">
            <span>
              <el-button @click="tabName = '1'">取 消</el-button>
              <el-button type="primary" @click="updateDic">确 定</el-button>
            </span>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import gql from "graphql-tag";
import axios from "axios";
import templateUeditor from "../../template/Ueditor";
export default {
  components: {
    templateUeditor,
  },
  name: "dic",
  data() {
    return {
      tagVisible: false,
      tagValue: "",
      tabName: "1",
      myConfig: {
        // 编辑器不自动被内容撑高
        autoHeightEnabled: false,
        // 初始容器高度
        initialFrameHeight: 240,
        // 初始容器宽度
        initialFrameWidth: "100%",
        // 上传文件接口（这个地址是我为了方便各位体验文件上传功能搭建的临时接口，请勿在生产环境使用！！！部署在国外的服务器，如果无法访问，请自备梯子）
        serverUrl: "",
        // UEditor 资源文件的存放路径，如果你使用的是 vue-cli 生成的项目，通常不需要设置该选项，vue-ueditor-wrap 会自动处理常见的情况，如果需要特殊配置，参考下方的常见问题2
        UEDITOR_HOME_URL: "/static/UEditor/",
      },
      dicEntity: {
        position: null,
        content: null,
        status: 1,
      },
      dicList: [],
      dataArgs: {
        take: 20,
        skip: 0,
        order: "-createTime",
        count: null,
        status: -1,
      },
    };
  },
  created() {
    this.getRichTextList();
  },
  methods: {
    getRichTextList() {
      this.$global
        .GraphqlQuery(
          this,
          getRichTexts,
          // Parameters
          this.dataArgs
        )
        .then((res) => {
          this.dataArgs.total = res.total;
          this.dicList = res.data;
          this.tabName = "1";
        });
    },
    updateDicDialog(item) {
      if (item) {
        //如果tag是从后端度过来的，会是{id,name}需要转换,如果是新添加的，会是string[]
        const entity = JSON.parse(JSON.stringify(item));
        this.dicEntity = entity;
      } else {
        this.dicEntity.id = null;
        this.dicEntity.tags = [];
      }
      this.tabName = "2";
    },
    changeTypeRadio() {
      this.dataArgs.skip = 0;
      this.getRichTextList();
    },
    changePage(val) {
      this.dataArgs.skip = (val - 1) * this.dataArgs.take;
      this.getRichTextList();
    },
    updateDic() {
      let { content, position, status } = this.dicEntity;
      const subEntity = { content, position, status };
      if (this.dicEntity.id) {
        this.$global
          .GraphqlMutation(this, updateRichText, {
            id: this.dicEntity.id,
            data: subEntity,
          })
          .then((res) => {
            this.$global.success(this, "操作成功");
            this.getRichTextList();
          });
      } else {
        this.$global
          .GraphqlMutation(this, addRichText, {
            data: subEntity,
          })
          .then((res) => {
            this.$global.success(this, "操作成功");
            this.getRichTextList();
          });
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.park {
  height: 100%;
}
.park-btn {
  margin: 10px;
}
.park-red {
  background-color: red;
  color: white;
  padding: 5px;
}
.park-green {
  background-color: green;
  color: white;
  padding: 5px;
}
.upload-image {
  max-width: 100%;
  max-height: 100%;
  vertical-align: middle;
  text-align: center;
}
.uni-tag {
  min-width: 50px;
  margin-right: 20px;
  display: inline-block;
}
.image-block {
  display: inline-block;
}
.picture-block {
  padding-top: 20px;
  border-top: 1px solid #d9d9d9;
  border-bottom: 1px solid #d9d9d9;
  height: 200px;
}
.picture-block-left {
  display: inline-block;
  width: 30%;
}
.picture-block-right {
  display: inline-block;
  width: 65%;
  vertical-align: top;
}
.picture-block-left img {
  max-width: 100%;
  max-height: 100%;
}
.picture-block-delete {
  position: absolute;
  right: 10px;
  bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/content/RichText.vue